import * as actionTypes from "./actionTypes";

const initialState = {
    values: {},
    loading: false,
    dataOfSearchFields: {
        availableEntities: {
            loading: false,
            error: undefined,
            data: []
        }
    },
    interfacesDetails: {},
    table: {
        data: [],
        sort: {
            property: undefined,
            direction: undefined
        },
        totalElements: undefined,
        pageNumber: undefined,
        totalPages: undefined
    },
    //form specific:
    interfaceData: {},

    interfaceList: [],

    loadingCreateRequest: false,
    loadingEditRequest: false,
    loadingDeleteRequest: false,

    interfaceWasCreated: false,
    interfaceWasEdited: false,
    interfaceWasDeleted: false,

    error: undefined,

    entityLastReadings: {},

    loadingUnitTypes: false,
    unitTypeList: [],

    loadingCategories: false,
    categoryList: []
};

const interfacesReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case actionTypes.GET_INTERFACE_LIST_REQUEST:
            return {
                ...state,
                loadingListRequest: true
            };
        case actionTypes.GET_INTERFACE_LIST_SUCCESS:
            return {
                ...state,
                loadingListRequest: false,
                interfaceList: payload
            };
        case actionTypes.GET_INTERFACE_LIST_FAILED:
            return {
                ...state,
                loadingListRequest: false,
                error: payload
            };
        case actionTypes.INTERFACE_SEARCH_REQUEST:
            return {
                ...state,
                loading: true
            };
        case actionTypes.INTERFACE_SEARCH_SUCCESS:
            return {
                ...state,
                loading:false,
                table: {
                    ...state.table,
                    data: payload.content,
                    totalPages: payload.totalPages,
                    totalElements: payload.totalElements,
                    sort: {
                        direction: payload.sort[0].direction,
                        property: payload.sort[0].property,
                    },
                    pageSize: payload.pageable.pageSize,
                    pageNumber: payload.pageable.pageNumber
                }
            };
        case actionTypes.INTERFACE_SEARCH_FAILED:
            return {
                ...state,
                loading:true
            }
        case actionTypes.GET_ENTITY_LAST_READINGS_REQUEST:
            return {
                ...state,
                loading:true
            }
        case actionTypes.GET_ENTITY_LAST_READINGS_SUCCESS:
            return {
                ...state,
                loading: false,
                entityLastReadings: payload,
            };
        case actionTypes.GET_ENTITY_LAST_READINGS_FAILED:
            return {
                ...state,
                loading:true,
                error: payload
            }
        case actionTypes.GET_INTERFACE_REQUEST:
            return {
                ...state,
                loading:true,
            };
        case actionTypes.GET_INTERFACE_SUCCESS:
            return {
                ...state,
                loading: false,
                interfaceData: payload,
            };
        case actionTypes.GET_INTERFACE_FAILED:
            return {
                ...state,
                loading: false,
            };
        case actionTypes.DELETE_INTERFACE_REQUEST:
            return {
                ...state,
                loadingDeleteRequest: true
            };
        case actionTypes.DELETE_INTERFACE_SUCCESS:
            return {
                ...state,
                loadingDeleteRequest: false,
                interfaceWasDeleted: true
            };
        case actionTypes.DELETE_INTERFACE_FAILED:
            return {
                ...state,
                loadingDeleteRequest: false,
                interfaceWasDeleted: false
            };
        case actionTypes.EDIT_INTERFACE_REQUEST:
            return {
                ...state,
                loadingEditRequest: true
            };
        case actionTypes.EDIT_INTERFACE_SUCCESS:
            return {
                ...state,
                loadingEditRequest: false,
                interfaceWasEdited: true
            };
        case actionTypes.EDIT_INTERFACE_FAILED:
            return {
                ...state,
                loadingEditRequest: false,
                interfaceWasEdited: false
            };
        case actionTypes.CREATE_INTERFACE_REQUEST:
            return {
                ...state,
                loadingCreateRequest: true
            };
        case actionTypes.CREATE_INTERFACE_SUCCESS:
            return {
                ...state,
                loadingCreateRequest: false,
                interfaceWasCreated: true
            };
        case actionTypes.CREATE_INTERFACE_FAILED:
            return {
                ...state,
                loadingCreateRequest: false,
                interfaceWasCreated: false
            };
        case actionTypes.RESET_INTERFACE_FORM:
            return {
                ...state,
                interfaceData: {},
                loadingCreateRequest: false,
                loadingEditRequest: false,
                loadingDeleteRequest: false,
                interfaceWasCreated: false,
                interfaceWasEdited: false,
                interfaceWasDeleted: false,
                error: undefined
            };
        case actionTypes.GET_ASSOCIATED_ENTITIES_LIST_REQUEST:
            return {
                ...state,
                loadingAssociatedEntities: true
            };
        case actionTypes.GET_ASSOCIATED_ENTITIES_LIST_SUCCESS:
            return {
                ...state,
                loadingAssociatedEntities: false,
                associatedEntitiesList: payload
            };
        case actionTypes.GET_ASSOCIATED_ENTITIES_LIST_FAILED:
            return {
                ...state,
                loadingAssociatedEntities: false,
            };
        case actionTypes.GET_UNIT_TYPE_LIST_REQUEST:
            return {
                ...state,
                loadingUnitTypes: true
            };
        case actionTypes.GET_UNIT_TYPE_LIST_SUCCESS:
            return {
                ...state,
                loadingUnitTypes: false,
                unitTypeList: payload
            };
        case actionTypes.GET_UNIT_TYPE_LIST_FAILED:
            return {
                ...state,
                loadingUnitTypes: false,
            };
        case actionTypes.GET_CATEGORY_LIST_REQUEST:
            return {
                ...state,
                loadingCategories: true
            };
        case actionTypes.GET_CATEGORY_LIST_SUCCESS:
            return {
                ...state,
                loadingCategories: false,
                categoryList: payload
            };
        case actionTypes.GET_CATEGORY_LIST_FAILED:
            return {
                ...state,
                loadingCategories: false,
            };
        case actionTypes.GET_TERMINALS_RELATED_ENTITIES_REQUEST:
            return {
                ...state,
                dataOfSearchFields: {
                    ...state.dataOfSearchFields,
                    availableEntities: {
                        ...state.dataOfSearchFields.availableEntities,
                        loading: true
                    }
                }
            };
        case actionTypes.GET_TERMINALS_RELATED_ENTITIES_SUCCESS:
            return {
                ...state,
                dataOfSearchFields: {
                    ...state.dataOfSearchFields,
                    availableEntities: {
                        ...state.dataOfSearchFields.availableEntities,
                        loading: false,
                        error: undefined,
                        data: payload
                    }
                }
            };
        case actionTypes.GET_TERMINALS_RELATED_ENTITIES_FAILED:
            return {
                ...state,
                dataOfSearchFields: {
                    ...state.dataOfSearchFields,
                    availableEntities: {
                        ...state.dataOfSearchFields.availableEntities,
                        loading: false,
                        error: payload,
                        data: []
                    }
                }
            };
        case actionTypes.LOAD_INTERFACES_DETAILS_SUCCESS:
            return {
                ...state,
                interfacesDetails: payload
            };
        case actionTypes.LOAD_INTERFACES_DETAILS_FAILED:
            return {
                ...state,
            };
        default:
            return state;
    }
};

export default interfacesReducer;